import React from "react";
import {Helmet} from "react-helmet";

function FraudioLoader({ src, title = "Yükleniyor", artist = "Ses hazırlanıyor..." }) {
    return (
        <>
            <Helmet>
                <script src="/assets/js/fraudio.min.js" defer></script>
            </Helmet>

            <audio
                className="fraudio"
                data-title={title}
                data-artist={artist}
                preload="none"
                controls={false}
            >
                <source src={src} type="audio/mpeg" />
            </audio>
        </>
    );
}

export default FraudioLoader;
